export async function getDataUrl(el) {
    return new Promise((resolve, reject) => {
        fetch(el.src)
            .then((res) => res.blob())
            .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.readAsDataURL(blob);
            });
    });
}